export type BlockType =
  | "hero"
  | "story"
  | "applications"
  | "certifications"
  | "cta"
  | "specs_grid"
  | "gallery"
  | "video";

export interface HeroBlockData {
  type: "hero";
  backgroundImage: string;
  overlayOpacity: number; // 0-100
  tagline: string;
  title: string;
  subtitle: string;
  ctaLabel: string;
  ctaLink: string;
  textAlign: "left" | "center" | "right";
}

export interface StoryItem {
  id: string;
  title: string;
  content: string;
  image: string;
  imagePosition: "left" | "right";
  accent: string;
}

export interface StoryBlockData {
  type: "story";
  items: StoryItem[];
}

export interface ApplicationItem {
  id: string;
  title: string;
  description: string;
  image_url: string;
}

export interface ApplicationsBlockData {
  type: "applications";
  title: string;
  subtitle: string;
  items: ApplicationItem[];
  layout: "grid" | "masonry" | "carousel";
}

export interface CertificationItem {
  id: string;
  title: string;
  type: "certification" | "patent" | "award";
  description: string;
  image_url: string;
}

export interface CertificationsBlockData {
  type: "certifications";
  title: string;
  items: CertificationItem[];
}

export interface CTABlockData {
  type: "cta";
  title: string;
  subtitle: string;
  backgroundColor: string;
  textColor: string;
  buttonLabel: string;
  buttonColor: string;
  showForm: boolean;
  formFields: { label: string; type: string; required: boolean }[];
}

export interface SpecsGridBlockData {
  type: "specs_grid";
  title: string;
  columns: 2 | 3 | 4;
  items: { label: string; value: string; icon?: string }[];
}

export interface GalleryBlockData {
  type: "gallery";
  title: string;
  layout: "2col" | "3col" | "masonry" | "staggered";
  images: { url: string; caption: string }[];
}

export interface VideoBlockData {
  type: "video";
  url: string;
  caption: string;
  poster: string;
  controls: boolean;
  autoplay: boolean;
  loop: boolean;
  muted: boolean;
}

export type BlockData =
  | HeroBlockData
  | StoryBlockData
  | ApplicationsBlockData
  | CertificationsBlockData
  | CTABlockData
  | SpecsGridBlockData
  | GalleryBlockData
  | VideoBlockData;

export interface BuilderBlock {
  id: string;
  data: BlockData;
}

export interface BuilderPage {
  id: string;
  name: string;
  blocks: BuilderBlock[];
}

// Default factories
export const createHeroBlock = (): HeroBlockData => ({
  type: "hero",
  backgroundImage: "",
  overlayOpacity: 50,
  tagline: "CÔNG NGHỆ HÀN QUỐC",
  title: "Tên sản phẩm nổi bật",
  subtitle: "Mô tả ngắn về sản phẩm và lợi ích chính",
  ctaLabel: "Liên hệ báo giá",
  ctaLink: "#contact",
  textAlign: "center",
});

export const createStoryBlock = (): StoryBlockData => ({
  type: "story",
  items: [
    {
      id: `story-${Date.now()}`,
      title: "Công nghệ tiên tiến",
      content: "<p>Mô tả về công nghệ và đặc điểm nổi bật của sản phẩm...</p>",
      image: "",
      imagePosition: "left",
      accent: "CÔNG NGHỆ MỚI",
    },
  ],
});

export const createApplicationsBlock = (): ApplicationsBlockData => ({
  type: "applications",
  title: "Ứng dụng thực tế",
  subtitle: "Sản phẩm được ứng dụng rộng rãi trong nhiều lĩnh vực",
  items: [],
  layout: "grid",
});

export const createCertificationsBlock = (): CertificationsBlockData => ({
  type: "certifications",
  title: "Bằng sáng chế & Chứng nhận",
  items: [],
});

export const createCTABlock = (): CTABlockData => ({
  type: "cta",
  title: "Liên hệ & Tư vấn báo giá",
  subtitle: "Nhận tư vấn miễn phí từ đội ngũ chuyên gia",
  backgroundColor: "#004A99",
  textColor: "#ffffff",
  buttonLabel: "Gửi yêu cầu",
  buttonColor: "#00AEEF",
  showForm: true,
  formFields: [
    { label: "Họ và tên", type: "text", required: true },
    { label: "Email", type: "email", required: true },
    { label: "Số điện thoại", type: "tel", required: false },
    { label: "Nội dung yêu cầu", type: "textarea", required: false },
  ],
});

export const createSpecsGridBlock = (): SpecsGridBlockData => ({
  type: "specs_grid",
  title: "Thông số kỹ thuật",
  columns: 3,
  items: [],
});

export const createGalleryBlock = (): GalleryBlockData => ({
  type: "gallery",
  title: "Thư viện hình ảnh",
  layout: "3col",
  images: [],
});

export const createVideoBlock = (): VideoBlockData => ({
  type: "video",
  url: "",
  caption: "",
  poster: "",
  controls: true,
  autoplay: false,
  loop: false,
  muted: false,
});